import { DC_COMPONENT_LABELS, PaidTimeOffPolicy } from "winslow-core";
import { DCBaseProps } from "./DCBase";
import { apiGetPaidTimeOffPolicy } from "../../../services/PaidTimeOffPolicyService";
import { useSelector } from "react-redux";
import { DCBreadcrumb, selectUser } from "../../../redux/features/appData";
import { useEffect, useState } from "react";
import { AppPTOPolicyEditor } from "../app-time-off/AppPTOPolicyEditor";
import { DCBreadcrumbs } from "./DCBreadcrumbs";
import { ArrowLeft } from "lucide-react";
import { Button, Icon } from "../../../ds2/components";
import { DCHeader } from "./DCHeader";



type DCPTOPolicyEditorProps = DCBaseProps & {
}

export const DCPTOPolicyEditor = ({data, isOutdated, onNavigation}: DCPTOPolicyEditorProps) => {
    const storeUser = useSelector(selectUser);

    const [ptoPolicy, setPtoPolicy] = useState<PaidTimeOffPolicy | null>(null);

    useEffect(() => {
        if (data) {
            console.log("[DCPTOPolicyEditor] data: ", data);
            (async () => {
                const thePolicy = await apiGetPaidTimeOffPolicy(data?.paidTimeOffPolicyId || "");
                setPtoPolicy(thePolicy);
            })();
        }
    }, [data]);

    const navigationCallback = (
        newObjectName: DC_COMPONENT_LABELS,
        newLabel: string,
        data: any
    ) => {
        console.log("[DCPTOPolicyEditor] navigationCallback data: ", data);
        // alert("navigationCallback: " + newObjectName + " " + newLabel);
        onNavigation?.(newObjectName, newLabel, data);
    }

    console.log("[DCPTOPolicyEditor] data: ", data);
    console.log("[DCPTOPolicyEditor] ptoPolicy: ", ptoPolicy);

    return (    
        <div className="dc-component-container">
            {/* <DCBreadcrumbs 
                breadcrumbs={[
                    {
                        objectName: "pto-policy",
                        label: "list",
                        data: data,
                        display: "PTO Policies"
                    },
                    {
                        objectName: "pto-policy",
                        label: data.label,
                        data: data,
                        display: data.label === "edit" ? "Edit PTO Policy" : "New PTO Policy"
                    } 
                ] as DCBreadcrumb[]}
                onNavigation={navigationCallback}
            /> */}
            <DCHeader 
                title={data.label === "edit" ? "Edit PTO Policy" : "New PTO Policy"}
                actions={[
                    <Icon
                        variant="tertiary"
                        size="sm"
                        icon={<ArrowLeft size={16} />}
                        onClick={() => {
                            navigationCallback("pto-policy", "list", data);
                        }}
                        border={true}
                        // label="Back"
                    />
                ]}
            />

            <div className="dc-component-card">
                <AppPTOPolicyEditor 
                    paidTimeOffPolicyId ={data?.paidTimeOffPolicyId || "new"}
                    onNavigation={navigationCallback}
                />
            </div>
        </div>
    );
}